import $ from 'jquery';
import './affix.scss';
import Sloth from '../Sloth';

@Sloth.component({
    defaultOptions:{
        t: 0
    }
})

export default class Affix {
    onInit() {
        alert('dd');
    }
}




/** WEBPACK FOOTER **
 ** ./components/Affix/affix.js
 **/